var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 75,
    viewBox: "0 0 49 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4828 0.808308L48.6103 17.3384L48.6198 17.3337C49.0087 17.8301 49.0941 18.4635 48.8996 19.0165L42.9951 35.6601L39.0445 83.3739C38.9687 84.3004 38.1909 85 37.2755 85H11.7272C10.7787 85 10.0009 84.2531 9.95349 83.3172L6.00766 35.6648L0.103133 19.0212C-0.124511 18.3831 0.0367366 17.7024 0.468312 17.2345L13.6148 0.680681C13.9657 0.241074 14.4827 0.0094539 15.0043 0.0094539V0H33.9937C34.615 0 35.1651 0.321433 35.4828 0.808308Z",
    fill: "#ADDC68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCasket);
export default __webpack_public_path__ + "static/media/green-casket.87c53b024631bbce3754184fd1721ff5.svg";
export { ForwardRef as ReactComponent };